import React from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Colis } from "@/interfaces/Return";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { ScanBarcode } from "lucide-react";
import ScannedColis_ from "./ScannedColis_";
import { checkColis } from "@/utils/colis-scan";

interface ProductColisScannerProps {
  colis: Colis[];
  setValidColis: React.Dispatch<React.SetStateAction<Colis[]>>;
}

const ProductColisScanner: React.FC<ProductColisScannerProps> = ({
  colis,
  setValidColis,
}) => {
  const [colisCode, setColisCode] = React.useState("");
  const [checkedColis, setCheckedColis] = React.useState<Colis[]>([]);

  const handleAddColis = () => {
    if (colisCode) {
      const colis_ = checkColis(colisCode, colis, checkedColis);
      if (colis_) {
        setCheckedColis([...checkedColis, colis_]);
      }
      setColisCode("");
    }
  };

  const handleColisCodeChange = (value: string) => {
    setColisCode(value.trim());
  };

  return (
    <>
      <div className="px-4 flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          <div className="text-sm text-muted-foreground">
            Progrès: {checkedColis.length} / {colis?.length || 0} colis scannés
          </div>
          <div className="flex items-center justify-between gap-2">
            <Input
              placeholder="Scanner un colis"
              className="w-full h-10"
              value={colisCode}
              onChange={(e) => handleColisCodeChange(e.target.value)}
              disabled={false}
              onKeyDown={(e) => {
                e.key === "Enter" && handleAddColis();
              }}
            />
            <Button
              variant="outline"
              className="h-10"
              disabled={false}
              onClick={() => handleAddColis()}
            >
              <ScanBarcode className="h-6 w-6" />
            </Button>
          </div>
        </div>
      </div>
      <div className="px-4 flex flex-grow flex-col gap-4">
        <ScrollArea className="flex-1 mt-2 max-h-[325px]" showScrollIndicator>
          {checkedColis &&
            checkedColis.map((colis_, index) => (
              <ScannedColis_
                key={index}
                colis={colis_}
                setValidColis={setValidColis}
              />
            ))}
        </ScrollArea>
      </div>
    </>
  );
};

export default ProductColisScanner;
